import {createFileRoute} from '@tanstack/react-router';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {ModelAddSamples} from '~components/models/samples/ModelAddSamples';
import {ModelProvider} from 'src/contexts/ModelProvider';

export const Route = createFileRoute('/model/add-samples/')({
  component: ModelAddSamplesPage,
});

function ModelAddSamplesPage(): JSX.Element {
  return (
    <ModelProvider mode='model-pages'>
      <BaseLayout customContentAndFooter showBackButton>
        <ModelAddSamples />
      </BaseLayout>
    </ModelProvider>
  );
}
